export default __webpack_public_path__ + "static/media/G89A3279.f0be21f0.jpg";